import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getProjetFichiers, uploadProjetFichier, deleteProjetFichier, downloadProjetFichier } from '../../api/PROJETS/projets';
import { toast } from 'react-toastify';

export const useGetProjetFichiers = (projetId) =>
  useQuery({
    queryKey: ["projetFichiers", projetId],
    queryFn: () => getProjetFichiers(projetId),
    enabled: !!projetId,
  });

export const useUploadProjetFile = (projetId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file) => uploadProjetFichier(projetId, file),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["projetFichiers", projetId] }),
  });
};

export const useDeleteProjetFile = (projetId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileId) => deleteProjetFichier(projetId, fileId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["projetFichiers", projetId] }),
  });
};

export const useDownloadProjetFile = (projetId) => {
  const download = async (fileId, filename) => {
    try {
      const blob = await downloadProjetFichier(projetId, fileId);
      
      // Création du lien temporaire
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename || "fichier"); // Force le téléchargement
      document.body.appendChild(link);
      
      link.click(); // Déclenche le téléchargement
      
      // Nettoyage
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Erreur hook download:", e);
      toast.error("Impossible de télécharger le fichier");
    }
  };

  const view = async (fileId) => {
    try {
      const blob = await downloadProjetFichier(projetId, fileId);
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (e) {
      console.error("Erreur hook view:", e);
      toast.error("Impossible d'ouvrir le fichier");
    }
  };

  return { download, view };
};
